import React from "react";

const Footer = () => {
  return (
    <div className="footer">
      <div className="copyright">
        <p>
          Copyright © Designed &amp; Developed by{" "}
          <a href="kisansolar.com" target="_blank"  rel="noreferrer">
          kisansolar.com
          </a>{" "}
          2022
        </p>
      </div>
    </div>
  );
};

export default Footer;
